// src/packages/chubb/pa/chubb_pa_series_a_2025/ChubbPASeriesACard.jsx
import React from "react";
import "./chubb_pa_series_a.css";

export default function ChubbPASeriesACard({ onSelect }) {
  return (
    <div className="pkg-card chubb-pa">
      <div className="pkg-body">
        <h3>Chubb PA Series A (แผน 1–8 + Kid)</h3>
        <p>อุบัติเหตุส่วนบุคคล • ค่ารักษา • วันหยุดสาธารณะ • มอเตอร์ไซค์</p>
        <ul className="pkg-list">
          <li>ทุนชีวิต/ทุพพลภาพ สูงสุดหลายล้านบาท (ตามแผน)</li>
          <li>ค่ารักษาพยาบาลต่อครั้ง และผลประโยชน์พิเศษอื่น ๆ</li>
          <li>เลือกทำเดี่ยว / คู่สมรส / ครอบครัว (รวมบุตรได้)</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
